import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {  WindowCloseResult, WindowRef, WindowService, WindowSettings, WindowState } from '@progress/kendo-angular-dialog';
import { Family,  IntUserPerimeters_XRP, IntUserStatut, Profil, PS_Lst_IntUsers_Result, PS_PAFX_DR_Result,  SharedDataService } from 'ngx-paf-common';
import { Subject } from 'rxjs';
import {IntUserDetailComponent} from '../int-user-detail/int-user-detail.component';

@Component({
  selector: 'int-user-window',
  templateUrl: './int-user-window.component.html',
  styleUrls: ['./int-user-window.component.scss']
})
export class IntUserWindowComponent implements OnInit {

  @Input() popupSettings : any = {
    width: 800,
    height:630,
    top:100,
    windowState: 'default'
  }
  @Input() showWindowSubject : Subject<any>;
  @Input() closeWindowSubject : Subject<any> = new Subject<any>();

  
  @Input() lstStatuts:IntUserStatut[] = [];
  @Input() lstFamilies:Family[]=[];
  @Input() lstPerimeters:IntUserPerimeters_XRP[]=[];
  @Input() lstProfils:Profil[]=[];
  @Input() lstUserEtbsXRP: PS_PAFX_DR_Result[] = [];
  @Input() lstAllEtbsXRP: PS_PAFX_DR_Result[] = [];
  @Input() lstIntUsers:PS_Lst_IntUsers_Result[]=[];
  @Output() onWindowClosed? : EventEmitter<WindowCloseResult> = new EventEmitter<WindowCloseResult>();
  constructor(
    private windowService: WindowService,
    public sharedDataSvc: SharedDataService) { }

  ngOnInit(): void {
    this.showWindowSubject.asObservable().subscribe((value:any) => {
      this.showWindow(value);
    });
  }



  public showWindow(showWindowParams:any) {
    let intUserId: number = showWindowParams.intUserId||0;
    let readOnly : boolean = !!(showWindowParams.readOnly);
    let windowSettings : WindowSettings= new WindowSettings();
    windowSettings.left=this.popupSettings.left;
    windowSettings.top=this.popupSettings.top;
    windowSettings.width=this.popupSettings.width;
    windowSettings.height=this.popupSettings.height;   
    windowSettings.state=<WindowState>this.popupSettings.windowState;
    windowSettings.resizable = true;
    windowSettings.draggable = true;
    windowSettings.appendTo = this.sharedDataSvc.mainContainerRef;
    windowSettings.title="Détail compte interne";
    windowSettings.content = IntUserDetailComponent;
    const windowRef: WindowRef = this.windowService.open(windowSettings);
    windowRef.window.instance.resizeEnd.subscribe(()=>{
      this.popupSettings.width = windowRef.window.instance.width;
      this.popupSettings.height = windowRef.window.instance.height;
      this.popupSettings.top = windowRef.window.instance.top;
      this.popupSettings.left = windowRef.window.instance.left;
    });
    windowRef.window.instance.stateChange.subscribe(()=>{
      this.popupSettings.windowState = <string>windowRef.window.instance.state;
    });
    windowRef.window.instance.dragEnd.subscribe(()=>{
      this.popupSettings.top = windowRef.window.instance.top;
      this.popupSettings.left = windowRef.window.instance.left;
    });
    this.closeWindowSubject.asObservable().subscribe((result)=>{
      
      windowRef.close(result);
    })
    
    windowRef.result.subscribe((result:WindowCloseResult)=>{
      windowRef.window.destroy();
      this.onWindowClosed.emit(result);
    });
    const containedComponent: IntUserDetailComponent  = windowRef.content.instance;
    containedComponent.closeWindowSubject = this.closeWindowSubject;
    containedComponent.lstFamilies = this.lstFamilies;
    containedComponent.lstIntUsers = this.lstIntUsers;
    containedComponent.lstPerimeters = this.lstPerimeters;
    containedComponent.lstProfils = this.lstProfils;
    containedComponent.lstStatuts = this.lstStatuts;
    containedComponent.lstUserEtbsXRP = this.lstUserEtbsXRP;
    containedComponent.lstAllEtbsXRP = this.lstAllEtbsXRP;
    containedComponent.intUserId = intUserId;
    containedComponent.readOnly = readOnly;
    containedComponent.windowTitleSubject.asObservable().subscribe((title:string) =>{
      if ((title||'') !='')  {
        windowRef.window.instance.title = title;
      } else {
        windowRef.window.instance.title = (containedComponent.intUserId==0) ? 'Création d\'un nouveau compte interne':'Détail compte interne';
      }
    })
  }

}
